import axios from 'axios';

async function deleteTeamRequest(team) {
  await axios.delete(`${process.env["NEXT_PUBLIC__USERDATA_API"]}/api/Filters/${team.id}`);
}

export { deleteTeamRequest };
//# sourceMappingURL=api.delete-team.request.js.map
